export const TransferReasons = [
  {
    DESC_ARB: 'نفقات لوجستية',
    DESC_ENG: 'Logistics Expenses',
    CODE: 'LOGISTICS_EXPENSES',
  },
  {
    DESC_ARB: 'نفقات معيشية',
    DESC_ENG: 'Living Expenses',
    CODE: 'LIVING_EXPENSES',
  },
  {
    DESC_ARB: 'رسوم السكن',
    DESC_ENG: 'Accommodation Fees',
    CODE: 'ACCOMMODATION_FEES',
  },
  {
    DESC_ARB: 'دفع الفواتير',
    DESC_ENG: 'Bill Payments',
    CODE: 'BILL_PAYMENTS',
  },
  {
    DESC_ARB: 'تسوية مالية',
    DESC_ENG: 'Finance Settlement',
    CODE: 'FINANCE_SETTLEMENT',
  },
  {
    DESC_ARB: 'دفع الإيجار',
    DESC_ENG: 'Rent Payment',
    CODE: 'RENT_PAYMENT',
  },
  {
    DESC_ARB: 'تحويل الراتب',
    DESC_ENG: 'Salary Transfer',
    CODE: 'SALARY_TRANSFER',
  },
  {
    DESC_ARB: 'رسوم دراسية',
    DESC_ENG: 'Tuition Fees',
    CODE: 'TUITION_FEES',
  },
  {
    DESC_ARB: 'دفعة تمويل شخصي',
    DESC_ENG: 'Personal Finance Payment',
    CODE: 'PERSONAL_FINANCE_PAYMENT',
  },
];